import { render, staticRenderFns } from "./DriverTicketDetail.vue?vue&type=template&id=33ee9b6a&scoped=true&"
import script from "./DriverTicketDetail.vue?vue&type=script&lang=js&"
export * from "./DriverTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketDetail.vue?vue&type=style&index=0&id=33ee9b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee9b6a",
  null
  
)

export default component.exports